"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const CardComponent = (props) => {
    const { children, header, id, className, setCardBody } = props;
    return (react_1.default.createElement("div", { className: "card", id: id },
        header ? react_1.default.createElement("div", { className: `card-header ${className}` }, header) : undefined,
        react_1.default.createElement("div", { className: setCardBody ? 'card-body' : '' }, children)));
};
CardComponent.propTypes = {
    children: prop_types_1.default.node.isRequired,
    header: prop_types_1.default.node,
    id: prop_types_1.default.string,
    className: prop_types_1.default.string,
    setCardBody: prop_types_1.default.bool,
};
CardComponent.defaultProps = {
    header: undefined,
    id: '',
    className: '',
    setCardBody: true,
};
exports.Card = CardComponent;
//# sourceMappingURL=Card.js.map